import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { RuntimeSettingsController } from "./RuntimeSettingsController";
import { SecurityController } from "./SecurityController";
import { TwoFactorController } from "./TwoFactorController";
import "./styles.css";

const overlayMode = window.location.pathname.startsWith("/overlay/");
if (overlayMode) {
  document.documentElement.classList.add("overlay-document");
  document.body.classList.add("overlay-document");
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
    {!overlayMode && <SecurityController />}
    {!overlayMode && <TwoFactorController />}
    {!overlayMode && <RuntimeSettingsController />}
  </StrictMode>,
);
